import Footer from './Footer'

const DefaultLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">{children}</div>
      </div>
      <Footer className="relative" />
    </div>
  )
}

export default DefaultLayout
